import { postRequest } from 'src/utils/http';
import { utilsController } from './consts';

export const validateCardNumber = async (cardNumberRequest) => 
        postRequest(`${utilsController}/validations/card-numbers`, cardNumberRequest);